import React from 'react';
import { TimeUtil } from '../../../../../util/TimeUtil';

interface LastNotesCardProps {
  id: number;
  name: string;
  date: number | string;
  onClick: () => void;
}

const LastNotesCardBold: React.FC<LastNotesCardProps> = ({ id, name, date, onClick }) => {
  return (
    <div
      key={`last-note-bold-${id}`}
      className="last-note-item style-bold-modern"
      onClick={onClick}
      tabIndex={0}
      role="button"
      onKeyPress={(evt) => {
        if (evt.key === 'Enter' || evt.key === ' ') {
          onClick();
        }
      }}
      aria-label={`Note: ${name}`}
    >
      <div className="last-notes-name text-center">{name}</div>
      <div className="d-flex justify-content-center">
        <div className="last-notes-date">
          {TimeUtil.formatDate(date)}
        </div>
      </div>
    </div>
  );
};

export default LastNotesCardBold;
